"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var exceptions = [];

function error(err) {
    console.error(err);
    exceptions.unshift(err);
}

function clear() {
    exceptions.splice(0, exceptions.length);
}

function getExceptions() {
    return exceptions;
}

exports.default = {
    error: error,
    clear: clear,
    getExceptions: getExceptions
};
module.exports = exports["default"];